import { contractRequest } from "@/portals/physician/api/transport";
import type {
  CancelledInvitation,
  InvitationStatus,
  ItemsResponse,
  PhysicianInvitation,
  PhysicianListItem,
  ResentInvitation,
} from "@/portals/physician/api/types";

// Same /api/v1/admin prefix as every other admin endpoint (see adminAuthApi.ts).
const BASE = "/api/v1/admin/physicians";

// Invite and resend send the email before responding (SMTP plus the image
// attachment), so they can outlast the default 30s client timeout — the
// admin would see "took too long" for an invite that actually went out.
const EMAIL_SENDING_TIMEOUT_MS = 90_000;

/** 201 · 409 EMAIL_ALREADY_REGISTERED · 409 INVITE_ALREADY_PENDING · 400 VALIDATION_ERROR */
export const createPhysicianInvitationApi = (email: string) =>
  contractRequest<PhysicianInvitation>(`${BASE}/invitations`, { method: "POST", body: { email }, portal: "admin", timeoutMs: EMAIL_SENDING_TIMEOUT_MS });

export const listPhysicianInvitationsApi = (status?: InvitationStatus) =>
  contractRequest<ItemsResponse<PhysicianInvitation>>(
    `${BASE}/invitations${status ? `?status=${status}` : ""}`,
    { method: "GET", portal: "admin" },
  );

/** Issues a new link (old one dies) and resets expiry · 409 INVITE_NOT_RESENDABLE · 409 EMAIL_ALREADY_REGISTERED */
export const resendPhysicianInvitationApi = (id: string) =>
  contractRequest<ResentInvitation>(`${BASE}/invitations/${encodeURIComponent(id)}/resend`, {
    method: "POST",
    portal: "admin",
    timeoutMs: EMAIL_SENDING_TIMEOUT_MS,
  });

/** 409 INVITE_NOT_CANCELLABLE */
export const cancelPhysicianInvitationApi = (id: string) =>
  contractRequest<CancelledInvitation>(`${BASE}/invitations/${encodeURIComponent(id)}/cancel`, { method: "POST", portal: "admin" });

export const listPhysiciansApi = () =>
  contractRequest<ItemsResponse<PhysicianListItem>>(BASE, { method: "GET", portal: "admin" });
